import { useQuery } from '@tanstack/react-query';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

/** @registry WBS adjustment type reference list. */
export function useWbsAdjustmentTypes() {
  return useQuery({
    queryKey: queryKeys.wbs.adjustmentTypes(),
    queryFn: ({ signal }) =>
      wbsApiClient.getAdjustmentTypes(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: { errorContext: 'WBS adjustment types' },
  });
}
